import React from 'react'
import './dialog.styles.scss'

const Dialog = props => {
    return (
        <div className="dialog">
            <div className="shade"></div>
            <div className="content">{props.children}</div>
        </div>
    )
}

export default Dialog
